import { render } from "./MessageSenderIdentifier.vue?vue&type=template&id=5657ea14&scoped=true"
import script from "./MessageSenderIdentifier.vue?vue&type=script&lang=js"
export * from "./MessageSenderIdentifier.vue?vue&type=script&lang=js"

import "./MessageSenderIdentifier.vue?vue&type=style&index=0&id=5657ea14&scoped=true&lang=css"

import exportComponent from "/Users/user/Development/spin-demo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5657ea14"]])

export default __exports__